import { Database, Server, Megaphone, Mail, Download, Layers } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const services = [
  {
    icon: Database,
    title: "Bases de datos personalizadas",
    desc: "Tú defines qué información, cómo y en qué formato. Recibes una base lista para usar, filtrada y actualizada.",
    size: "lg:col-span-2 lg:row-span-2",
    highlight: true,
  },
  {
    icon: Server,
    title: "Poblamiento de datos",
    desc: "Rellenamos tus sistemas y CRMs con datos estructurados y limpios.",
    size: "lg:col-span-2",
  },
  {
    icon: Megaphone,
    title: "Ideal para campañas",
    desc: "Bases optimizadas para email marketing, telemarketing y campañas B2B.",
    size: "lg:col-span-1",
  },
  {
    icon: Mail,
    title: "Garantía sobre correos",
    desc: "Reemplazamos correos desactualizados sin costo adicional.",
    size: "lg:col-span-1",
  },
  {
    icon: Download,
    title: "Descarga instantánea",
    desc: "Recibe tu base inmediatamente después de la confirmación.",
    size: "lg:col-span-2",
  },
];

export default function Services() {
  return (
    <section id="servicios" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff] mb-4">
              / 01 — Servicios
            </div>
            <h2 className="font-display font-black text-white text-4xl sm:text-5xl leading-[1] tracking-tight">
              Datos que se{" "}
              <span className="italic font-light text-[#00f0ff]">adaptan</span>{" "}
              a ti.
            </h2>
          </div>
          <p className="text-[#94a3b8] text-base max-w-md leading-relaxed">
            No usamos plantillas genéricas. Cada base se construye a la medida
            exacta de lo que tu equipo necesita para vender más.
          </p>
        </div>

        <div
          data-testid={TESTIDS.servicesGrid}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[200px]"
        >
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`glass-card relative p-7 overflow-hidden group ${s.size} ${
                  s.highlight
                    ? "bg-gradient-to-br from-[rgba(0,240,255,0.08)] to-[rgba(10,18,36,0.6)]"
                    : ""
                }`}
              >
                {s.highlight && (
                  <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#00f0ff]/10 rounded-full blur-3xl" />
                )}
                <div className="relative h-full flex flex-col">
                  <div
                    className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-colors ${
                      s.highlight
                        ? "bg-[#00f0ff] text-[#040812]"
                        : "bg-[rgba(0,240,255,0.08)] text-[#00f0ff] border border-[rgba(0,240,255,0.2)]"
                    }`}
                  >
                    <Icon size={s.highlight ? 24 : 20} />
                  </div>

                  <h3 className="font-display font-bold text-white text-xl leading-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-[14px] text-[#94a3b8] leading-relaxed flex-1">
                    {s.desc}
                  </p>

                  {s.highlight && (
                    <div className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-[#00f0ff]">
                      <Layers size={12} />
                      Servicio principal
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
